import Base from './components/cells/Base';
import Flag from './components/cells/Flag';

export default function BooleanCell() {}

BooleanCell.prototype.init = function (params) {
    this.eGui = Base(Flag(params), params);
    return;
};

BooleanCell.prototype.getGui = function () {
    return this.eGui;
};
